/**
 * Samweb WebClient
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { GetChatAuthTokenResponseData } from '../model/getChatAuthTokenResponseData';
import { GetChatDetailsResponseData } from '../model/getChatDetailsResponseData';
import { GetChatGuestInfoResponseData } from '../model/getChatGuestInfoResponseData';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ChatsService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param callId 
     * @param messageId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public closeChat(callId: number, messageId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public closeChat(callId: number, messageId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public closeChat(callId: number, messageId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public closeChat(callId: number, messageId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (callId === null || callId === undefined) {
            throw new Error('Required parameter callId was null or undefined when calling closeChat.');
        }

        if (messageId === null || messageId === undefined) {
            throw new Error('Required parameter messageId was null or undefined when calling closeChat.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (callId !== undefined && callId !== null) {
            queryParameters = queryParameters.set('CallId', <any>callId);
        }
        if (messageId !== undefined && messageId !== null) {
            queryParameters = queryParameters.set('MessageId', <any>messageId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('post',`${this.basePath}/api/chats/close`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param callId 
     * @param messageId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getChatDetails(callId: number, messageId: string, observe?: 'body', reportProgress?: boolean): Observable<GetChatDetailsResponseData>;
    public getChatDetails(callId: number, messageId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetChatDetailsResponseData>>;
    public getChatDetails(callId: number, messageId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetChatDetailsResponseData>>;
    public getChatDetails(callId: number, messageId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (callId === null || callId === undefined) {
            throw new Error('Required parameter callId was null or undefined when calling getChatDetails.');
        }

        if (messageId === null || messageId === undefined) {
            throw new Error('Required parameter messageId was null or undefined when calling getChatDetails.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (callId !== undefined && callId !== null) {
            queryParameters = queryParameters.set('CallId', <any>callId);
        }
        if (messageId !== undefined && messageId !== null) {
            queryParameters = queryParameters.set('MessageId', <any>messageId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetChatDetailsResponseData>('get',`${this.basePath}/api/chats/details`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getChatDetailsByUid(uid: string, observe?: 'body', reportProgress?: boolean): Observable<GetChatDetailsResponseData>;
    public getChatDetailsByUid(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetChatDetailsResponseData>>;
    public getChatDetailsByUid(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetChatDetailsResponseData>>;
    public getChatDetailsByUid(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling getChatDetailsByUid.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (uid !== undefined && uid !== null) {
            queryParameters = queryParameters.set('Uid', <any>uid);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetChatDetailsResponseData>('get',`${this.basePath}/api/chats/details-by-uid`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param callId 
     * @param messageId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getChatGuestInfo(callId: number, messageId: string, observe?: 'body', reportProgress?: boolean): Observable<GetChatGuestInfoResponseData>;
    public getChatGuestInfo(callId: number, messageId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetChatGuestInfoResponseData>>;
    public getChatGuestInfo(callId: number, messageId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetChatGuestInfoResponseData>>;
    public getChatGuestInfo(callId: number, messageId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (callId === null || callId === undefined) {
            throw new Error('Required parameter callId was null or undefined when calling getChatGuestInfo.');
        }

        if (messageId === null || messageId === undefined) {
            throw new Error('Required parameter messageId was null or undefined when calling getChatGuestInfo.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (callId !== undefined && callId !== null) {
            queryParameters = queryParameters.set('CallId', <any>callId);
        }
        if (messageId !== undefined && messageId !== null) {
            queryParameters = queryParameters.set('MessageId', <any>messageId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetChatGuestInfoResponseData>('get',`${this.basePath}/api/chats/guest`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getChatToken(observe?: 'body', reportProgress?: boolean): Observable<GetChatAuthTokenResponseData>;
    public getChatToken(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetChatAuthTokenResponseData>>;
    public getChatToken(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetChatAuthTokenResponseData>>;
    public getChatToken(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetChatAuthTokenResponseData>('get',`${this.basePath}/api/chats/token`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param callId 
     * @param messageId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public openChat(callId: number, messageId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public openChat(callId: number, messageId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public openChat(callId: number, messageId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public openChat(callId: number, messageId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (callId === null || callId === undefined) {
            throw new Error('Required parameter callId was null or undefined when calling openChat.');
        }

        if (messageId === null || messageId === undefined) {
            throw new Error('Required parameter messageId was null or undefined when calling openChat.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (callId !== undefined && callId !== null) {
            queryParameters = queryParameters.set('CallId', <any>callId);
        }
        if (messageId !== undefined && messageId !== null) {
            queryParameters = queryParameters.set('MessageId', <any>messageId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/api/chats/open`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
